<template lang="html">

  <section class="register" >
    <div class="pageHeading">
      <h1 v-if="this.$route.name == 'register'">Create New Account</h1>
      <h1 v-else>Set New Password</h1>
    </div>
    <v-form ref="form" v-model="valid">

      <span style="color:red;">Note: If you are a director please contact us and we will create your director admin account.</span>


      <v-text-field
              v-if="this.$route.name == 'register'"
              v-validate="'required|email'"
              v-model="email"
              :error-messages="errors.collect('email')"
              label="E-mail"
              data-vv-name="email"
              data-vv-as="Email"
              required
      ></v-text-field>
      <v-text-field
              v-validate="'required'"
              :error-messages="errors.collect('password')"
              v-model="password"
              label="Password"
              ref="password"
              data-vv-name="password"
              type="password"
              data-vv-as="Password"
              required
      ></v-text-field>
      <v-text-field
              v-validate="'required|confirmed:password'"
              :error-messages="errors.collect('passwordConfirm')"
              v-model="passwordConfirm"
              label="Password Confirm"
              data-vv-name="passwordConfirm"
              type="password"
              data-vv-as="Password Confirmation"
              required
      ></v-text-field>
      <v-divider></v-divider><br/>
      <v-checkbox v-model="optinBox" v-if="this.$route.name == 'register'" style="margin:0px; padding: 0px"
                  hide-details label="I opt-in to receive invoice and payment reminder emails." ></v-checkbox>
      <br/><v-divider></v-divider><br/>
      <div v-bind:class="{ errorShake: shakeThat }">
        <p style="color: red" v-if="error.length > 0">{{error}}</p>

        <div v-if="this.$route.name == 'register'">
        <v-btn color="secondary"  @click="$router.push('/Login')" dark>I Have An Account</v-btn>
        <v-btn color="primary" :disabled="waitingOnServer || !optinBox" @click="doSignUp">Sign up</v-btn>
        </div>
        <div v-else>
          <v-btn  color="primary" :disabled="waitingOnServer" @click="doPasswordChange">Change Password & Login</v-btn>
        </div>
      </div>
    </v-form>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'register',
    props: [],
    mounted() {
        console.log('mounted register', this.$route.query.trip)
    },
    created: function() {
      },
    data() {
        return {
          optinBox: false,
            shakeThat: false,
            error: '',
            valid: false,
            name: '',
            email: '',
            password: '',
            passwordConfirm: '',
            waitingOnServer: false,
            tripNumber: '',
            dictionary: {
                attributes: {
                    email: 'E-mail Address',
                    tripNumber: 'Trip ID'
                    // custom attributes
                },
                custom: {
                    name: {
                        required: () => 'Name can not be empty',
                        max: 'The name field may not be greater than 10 characters'
                        // custom messages
                    },
                    tripNumber: {
                        required: () => 'Trip ID can not be empty'
                        // custom messages
                    }

                    }
            }
        }
    },
    methods: {
        doPasswordChange() {
            this.$refs.form.validate()

            if(!this.valid) {
                this.shakeThat = true;
                setTimeout(()=>{
                    this.shakeThat = false
                }, 500)
                return false;
            }

            var vueThis = this;
            var resetToken = this.$route.query.token

            this.waitingOnServer = true;
            this.$services.authmanagement.create({
                "action": "resetPwdLong",
                "value": { "token": resetToken, "password": vueThis.password}
            }).then((test) => {
                console.log('test', test)
                alert('Password changed! You will be redirected to login now.')
                vueThis.$router.push('/Login')
            }).catch(function(error){
                if(error.message.indexOf('No record found') !== -1) {
                    alert('Invalid or expired password reset link')
                    vueThis.$router.push('/Recovery')
                }
                console.error('Error!', error);
                vueThis.error = error.message;
                vueThis.shakeThat = true;
                setTimeout(()=>{
                    vueThis.shakeThat = false
                }, 500)
            })
                .finally(() => {
                    vueThis.waitingOnServer = false;

                })
        },
        doSignUp () {

            this.$refs.form.validate()

            if(!this.valid) {
                this.shakeThat = true;
                setTimeout(()=>{
                    this.shakeThat = false
                }, 500)
                return false;
            }

            var vueThis = this;

            this.waitingOnServer = true;
            this.$services.users.create({
                "email": vueThis.email.trim().toLowerCase(),
                "password": vueThis.password,
                "firstName" : "",
                "lastName" : "",
                "invited" : false,
                "tripIDInvite" : vueThis.$route.query.trip,
                "phone" : "",
                "billingAddress" : {},
                "resetToken": "",
                "permissions": [ "adult" ],
                "subUsers": [],
                "notifsRead":0,
                "trips": [],
                "businesses" : [],
                "setup" : false,
                "disabled" : false,
                "verificationCode" : "234",
                "emailVerified" : false
            }).then((test) => {
                console.log('test', test)
                alert('Account created! We emailed you an email verification code. Please click the link before logging in.')
                vueThis.$router.push('/Login')
            }).catch(function(error){
                console.error('Error!', error);
                vueThis.error = error.message;
                vueThis.shakeThat = true;
                setTimeout(()=>{
                    vueThis.shakeThat = false
                }, 500)
            })
                .finally(() => {
                vueThis.waitingOnServer = false;

            })
        }

    },
    computed: {

    }
}
</script>

<style lang="scss">
</style>
